import { ANALYTICS_EVENTS, ANALYTICS_PROPERTY_KEYS, COMPONENT_OUTCOMES, DCM_PAGES } from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';

export type TrackBudgetEnteredParams = {
  campaignId?: string;
  lineItemId?: string;
  adAccountId?: string;
  budgetAmount: number;
};

export const trackBudgetEntered = ({
  campaignId,
  lineItemId,
  adAccountId,
  budgetAmount,
}: TrackBudgetEnteredParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.BUDGET_ENTERED, {
    [ANALYTICS_PROPERTY_KEYS.CAMPAIGN_ID]: campaignId,
    [ANALYTICS_PROPERTY_KEYS.LINE_ITEM_ID]: lineItemId,
    [ANALYTICS_PROPERTY_KEYS.AD_ACCOUNT_ID]: adAccountId,
    [ANALYTICS_PROPERTY_KEYS.BUDGET_AMOUNT]: budgetAmount,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.CAMPAIGN_BUILDER,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};
